import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import MultiSelectBox from '../../../../../../../features/components/Form/MultiSelectBox'

import { getValidFormattedExchangeTargetingOptions } from '../../../../../lineItemHelpers'

import {
  clearGetDv360ExchangeTargetingOptions,
  getDv360ExchangeTargetingOptions
} from '../../../../../../../modules/actions/dv360Constants'
import { selectedDV360AdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'
import {
  dv360ExchangeTargetingOptionsSelector,
  getDv360ExchangeTargetingOptionsIsLoadingSelector
} from '../../../../../../../modules/selectors/dv360Constants'

import { ALL_EXCHANGES, CUSTOM_EXCHANGES, EXCHANGE_OPTION } from '../../fields'

const ExchangesStep = ({ formik }) => {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)
  const getDv360ExchangeTargetingOptionsIsLoading = useSelector(getDv360ExchangeTargetingOptionsIsLoadingSelector)
  const dv360ExchangeTargetingOptions = useSelector(dv360ExchangeTargetingOptionsSelector)

  const { values, setFieldValue, errors, touched } = formik

  const exchangeError = errors[CUSTOM_EXCHANGES]
  const exchangeTouched = touched[CUSTOM_EXCHANGES]

  const formattedExchangeTargetingOptions = useMemo(() => {
    return getValidFormattedExchangeTargetingOptions(dv360ExchangeTargetingOptions)
  }, [dv360ExchangeTargetingOptions])

  useEffect(() => {
    dispatch(
      getDv360ExchangeTargetingOptions({
        account: selectedAdAccountId
      })
    )
  }, [dispatch, selectedAdAccountId])

  useEffect(() => {
    return () => {
      dispatch(clearGetDv360ExchangeTargetingOptions())
    }
  }, [dispatch])

  return (
    <Step stepTitle="Which Exchanges would you like this line item to run on?">
      <RadioBlock
        setFieldValue={setFieldValue}
        id={EXCHANGE_OPTION + ALL_EXCHANGES}
        name={EXCHANGE_OPTION}
        value={ALL_EXCHANGES}
        selectedValue={values[EXCHANGE_OPTION]}
        label={t('All Exchanges')}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id={EXCHANGE_OPTION + CUSTOM_EXCHANGES}
        name={EXCHANGE_OPTION}
        value={CUSTOM_EXCHANGES}
        selectedValue={values[EXCHANGE_OPTION]}
        label={t('Custom Exchanges')}
        error={exchangeError}
        touched={exchangeTouched}
      >
        <MultiSelectBox
          placeholder={t('Custom exchanges')}
          options={formattedExchangeTargetingOptions}
          name={CUSTOM_EXCHANGES}
          value={values[CUSTOM_EXCHANGES]}
          isLoading={getDv360ExchangeTargetingOptionsIsLoading}
          setFieldValue={setFieldValue}
        />
      </RadioBlock>
    </Step>
  )
}

export default ExchangesStep
